const HomePage = () => {
  return <div>Welcome to the Phonebook manager</div>;
};

export default HomePage;
